import axios from "axios";
import { toast } from "react-toastify";

const externalInstance = axios.create({
  // baseURL: 'http://localhost:3000/api/v1/',
  baseURL: 'https://superscore.in/api/v1/',
});

// Add a response interceptor
externalInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors
    if (error.response && error.response.status === 401) {
      toast.error("External server authentication failed.", { theme: "colored" });
    }
    return Promise.reject(error);
  }
);

export default externalInstance;

